import React from 'react';
import { Label, TextField, Text, Stack, Icon } from '@fluentui/react';
import ComboBoxSearch from '../../Common/ComboBoxSearch';
import { IComboBoxOption, Image } from '@fluentui/react';
import { Club } from '../../../system/Club/Club';
import { DocumentoTipo } from '../../../system/DocumentoTipo/DocumentoTipo';
import { Jugador } from '../../../system/Jugador/Jugador';
import SingleFileDropzone from '../../Common/FileDropzone/SingleFileDropzone';
import DialogTemplate from '../../Common/DialogTemplate';
import { formatFileSize, isImage, obtenerExtension } from './SubirComprobanteMedico';
import { checkMaxSize } from '../WizardAptoFisico';

interface IContacto {
  jugador: Jugador;
  telefono: string;
  email: string;
  setTelefono: (value: string) => void;
  setEmail: (value: string) => void;
  onDropSelfie: (file: File) => void;
  fileSelfie: File | null;
}

export const Contacto = (props: IContacto) => {
  const [disableInputs, setDisableInputs] = React.useState(!(!props.email && !props.telefono));
  // const url = React.useMemo(() => {
  //   if (props.fileSelfie) {
  //     const url = URL.createObjectURL(props.fileSelfie!);
  //     return url;
  //   }
  //   return '';
  // }, [props.fileSelfie]);
  return (
    <div>
      <div>
        <Label>Email</Label>
        <TextField
          // disabled={disableInputs}
          value={props.email}
          onChange={(e, nv) => props.setEmail(nv ? nv : '')}
          type="email"
          required
          description="Te vamos a notificar a este email"
        />
      </div>
      <div>
        <Label>Telefono</Label>
        <TextField
          disabled={disableInputs}
          value={props.telefono}
          onChange={(e, nv) => props.setTelefono(nv ? nv : '')}
          type="tel"
        />
      </div>
      <div style={{ minHeight: 20 }}>
        <Text
          variant="small"
          className="float-right mt-1 link-styles"
          onClick={() => (disableInputs ? setDisableInputs(false) : null)}
        >
          Editar
        </Text>
      </div>
      {/* <Stack horizontalAlign="center" className="text-center mt-1">
        {' '}
        <SingleFileDropzone
          label="Foto del jugador"
          icon="Camera"
          onDrop={(file) => props.onDropSelfie(file)}
        ></SingleFileDropzone>
      </Stack>{' '} */}
      {/* <div className="text-center">
        <Text variant="xSmall" className="" title="Formatos admitidos">
          (JPG, JPEG, GIF, PNG)
        </Text>
      </div> */}
      <div className="mt-5">
        <Text variant="small" className="error-color">
          <Icon
            iconName="AlertSolid"
            className="error-color"
            style={{ position: 'relative', top: 2, marginRight: 3 }}
          ></Icon>
          El contenido subido queda bajo exclusiva responsabilidad del presentante
        </Text>
      </div>
      {props.fileSelfie && (
        <div className="mt-2 text-center">
          <Text block variant="medium" className="">
            <Icon iconName="SkypeCircleCheck" style={{ color: '#107C10', marginRight: 10 }}></Icon>
            Archivo {obtenerExtension(props.fileSelfie.name)} cargado -{' '}
            {formatFileSize(props.fileSelfie.size)}
          </Text>
          {!checkMaxSize(props.fileSelfie.size) && (
            <Text block variant="medium" className="error-color">
              El tamaño de la foto es demasiado grande, el maximo es de 20MB
            </Text>
          )}
        </div>
      )}
    </div>
  );
};
